import { Icon, ICONS } from 'components/Icon';
import { ItemDetails } from 'components/ItemDetails';
import { Pressable } from 'components/Pressable';
import { CloudThumbnail } from 'components/Thumbnail/CloudThumbnail';
import { LocalThumbnail } from 'components/Thumbnail/LocalThumbnail';
import { useAlert } from 'hooks/useAlert';
import { rbAddReferencePrefix } from 'lib/riskbase';
import { theme } from 'lib/theme';
import React from 'react';
import { View } from 'react-native';
import { APIRemoteUrl } from 'service/api/constants';

type Props = {
  remoteImageUrl?: APIRemoteUrl;
  hasChanges?: boolean;
  details: {
    name: string;
    avatar: string;
    reference: string;
    customReference: string;
    parentName: string;
    address1: string;
    address2: string;
    city: string;
    county: string;
    postcode: string;
  };
};

export const AssetSummaryRow: React.FC<Props> = ({
  hasChanges,
  details,
  remoteImageUrl,
}) => {
  const alert = useAlert();

  return (
    <View
      style={{
        alignItems: 'center',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      <View style={{ marginRight: theme.paddingHorizontal, width: 70 }}>
        {remoteImageUrl ? (
          <CloudThumbnail
            imageUrl={remoteImageUrl(details.avatar)}
            width={70}
            height={70}
            rounded
          />
        ) : (
          <LocalThumbnail
            thumbnailId={details.avatar}
            width={70}
            height={70}
            rounded
          />
        )}
        {hasChanges && (
          <Pressable
            onPress={() =>
              alert({
                text:
                  "Changes you've made to this asset have not been uploaded to RiskBase Cloud yet.\n\n" +
                  'Connect to the internet and tap the sync indicator.',
              })
            }
            style={{
              borderRadius: 21,
              bottom: -2,
              height: 21,
              padding: 1,
              position: 'absolute',
              right: -2,
              width: 21,
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: theme.colors.red,
              borderColor: theme.colors.white,
              borderWidth: 1,
            }}
          >
            <Icon
              source={ICONS.CloudSolid}
              color={theme.colors.white}
              size={13}
            />
          </Pressable>
        )}
      </View>
      <ItemDetails
        subsubtitle={
          rbAddReferencePrefix(details.reference) +
          (details.customReference ? ` • ${details.customReference}` : '')
        }
        title={details.name}
        subtitle={[
          details.parentName,
          details.address1,
          details.address2,
          details.city,
          details.county,
          details.postcode,
        ]
          .filter((item) => !!item)
          .join(', ')}
      />
    </View>
  );
};
